<template>
    <el-dialog
            :title="payName" class="fotoo"
            :visible.sync="dialogVisible"
            width="50%" append-to-body
            :before-close="handleClose">
        <div class="solid-top flex flex-direction align-center padding-xl">
            <div class="margin-bottom-xl flex-direction flex align-center">
                <div class="text-gray margin-bottom-xl">应付金额：<span class="padding-left text-black">{{amount/100}}元</span></div>
                <div class="qrcode" ref="qrCodeUrl">loading...</div>
                <div class="text-black margin-top-xl">使用<span class="text-red">微信</span>APP扫码完成支付</div>
            </div>
            <button class="cu-btn bg-green padding-lr-xl radius" @click="gotoHome">完 成</button>
            <div class="text-gray margin-top-xl flex flex-direction align-start justify-start" style="width: 80%;">
                支付遇到的问题：<br/>
                1.暂不支持支付宝支付
                <div class="flex">
                    2.如果遇到你无法解决的问题，<a href="https://openai.weixin.qq.com/webapp/jDgwDGsnHz8LXBmMwbNBffXZuPqmsS?robotName=Fotoo%E5%BE%81%E9%9B%86%E4%B8%80%E4%B8%8B" target="_blank">及时联系我们</a>
                </div>

            </div>
        </div>
    </el-dialog>
</template>
<script>
  import App from '../../../util/comfun'
  import QRCode from 'qrcodejs2'
  export default {
    props:{

    },
    data () {
      return {
        dialogVisible:false,
        payName:'微信支付',
        amount:0,
      }
    },
    methods:{
      handleClick(){},
      handleClose(done) {
        done();
      },
      show(res){
        console.log('show',res)
        if(res.payName) this.payName=res.payName
        this.amount=res.amount
        this.trafficUser=res.trafficUser
        //this.serviceKey=res.serviceKey
        let params={
          serviceKey:res.serviceKey,
          tradeType:2,
          count:res.count||1,
          userId:this.trafficUser.id,
        }
        this.dialogVisible=true
        setTimeout(()=>{
          this.$refs.qrCodeUrl.innerHTML='loading...'
        },0)
        App.demand('/activity/payment/pay','POST',params).then(res=>{
          if(res.code!=200) return this.$message.error(res.message||'调用支付失败')
          this.codeUrl=res.data.codeUrl
          setTimeout(()=>{
            this.creatQrCode()
          },0)
        })
      },
      creatQrCode() {
        this.$refs.qrCodeUrl.innerHTML=''
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: this.codeUrl,
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      gotoHome(){
        this.$router.back()
      },
    },
    mounted(){

    },

  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/components/checkout/dialogCode.vue